module.exports = __webpack_public_path__ + "img/Frame-52.63dc1537.svg";